import {
    deleteFuelRobItem,
    getAllFuelRobItems,
    deleteBunkeringItem,
    getAllBunkeringItems,
    deleteBunkeringStatusItem,
    getAllBunkeringStatusItems,
} from 'src/api/bunkering/offlineBunkeringApi';
import useSyncHelper from './useSyncHelper';

const useSyncOfflineBunkering = () => {
    const { syncItems } = useSyncHelper();

    const syncFuelRobItems = () => syncItems(getAllFuelRobItems, deleteFuelRobItem, ['upsertFuelRobDataRequest'], 'aolDate');
    const syncBunkeringItems = () => syncItems(getAllBunkeringItems, deleteBunkeringItem, ['upsertBunkeringRequest'], 'bunkeringGuid');
    const syncBunkeringStatusItems = () => {
        syncItems(
            getAllBunkeringStatusItems,
            deleteBunkeringStatusItem,
            ['upsertBunkeringStatusRequest', 'deleteBunkeringStatusRequest'],
            'bunkeringStatusGuid'
        );
    };

    const syncBunkerings = () => {
        syncFuelRobItems();
        syncBunkeringItems();
        syncBunkeringStatusItems();
    };

    return {
        syncBunkerings,
    };
};

export default useSyncOfflineBunkering;
